import type { FC } from 'react';

/** Sahifa bo'lagi yuklanayotganda — sahifa skeleti. */
export const PageFallback: FC = () => (
  <main className="page" aria-busy="true">
    <div className="skeleton skeleton-card" style={{ height: 160 }} />
    <div className="skeleton skeleton-line" style={{ width: '70%' }} />
    <div className="skeleton skeleton-line" style={{ width: '45%' }} />
  </main>
);
